import { render, staticRenderFns } from "./RemindAPForm.vue?vue&type=template&id=5ac08749"
import script from "./RemindAPForm.vue?vue&type=script&lang=js"
export * from "./RemindAPForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports